import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    files: [],
    status: "",
    error: null,
};

export const uploadSlice = createSlice({
    name: "uploadSlice",
    initialState,
    reducers: {
        setUploadFile: (state, action) => {
            state.files = [...state.files, action.payload];
        },
        resetUploadFile: (state) => {
            state.files = [];
        },
    },
});

export const selectUploadFiles = (state) => state.uploadSlice.files;
export const { setUploadFile, resetUploadFile } = uploadSlice.actions;